import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.temperatureListFilter.loading;
export const selectErrorMessage = (state: RootState) =>
  state.temperatureListFilter.error;
export const temperatureListFilterDataResponse = (state: RootState) =>
  state.temperatureListFilter.temperatureFilterListResponse;
